import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { ContainersTab } from "./containers.js";
import { DispatchTab } from "./dispatch.js";
import { RoutesTab } from "./routes.js";

type Tab = "dispatch" | "routes" | "containers";

export function DistributionPage() {
  const [tab, setTab] = useState<Tab>("dispatch");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <div className="row wrap" style={{ alignItems: "center" }}>
        <Seg<Tab>
          label="بخش مدیریت توزیع"
          value={tab}
          onChange={setTab}
          options={[
            { value: "dispatch", label: "توزیع امروز" },
            { value: "routes", label: "قالب‌های مسیر" },
            { value: "containers", label: "ظروف امانی" },
          ]}
        />
      </div>

      {tab === "dispatch" && <DispatchTab />}
      {tab === "routes" && <RoutesTab />}
      {tab === "containers" && <ContainersTab />}
    </div>
  );
}
